module.exports = __webpack_public_path__ + "static/img/meilizhihui.ae0623f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/meilizhihui.png
// module id = Quxa
// module chunks = 1